
export default function useStyles() {
    return  theme => ({
        paper: {
            position: 'absolute',
            width: 900,
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[5],
            padding: 20,
        },
        '@media only screen and (max-width: 600px)': {
            paper: {
                width: '90%',
            },
        },
        buttonCancelar: {
            color: 'gray'
        },
        tituloModalRemove: {
            marginBottom: '20px'
        }
    });
}